import React from 'react';
import ReactModal from 'react-modal';
import styles from './layoff.module.scss';

/**
 * Modal shell with the app's usual modal-head / modal-body markup
 */
const LayoffModal = ({ isOpen, title, onClose, children, wide = false }) => (
  <ReactModal
    isOpen={isOpen}
    contentLabel={title}
    onRequestClose={onClose}
    ariaHideApp={false}
    overlayClassName={styles.overlay}
    className={`${styles.modal} ${wide ? styles.modal_wide : ''}`}
  >
    <div className={styles.modal_head}>
      <h4>{title}</h4>
      <button
        type='button'
        className={styles.icon_button}
        aria-label='Close'
        onClick={onClose}
      >
        <img
          alt=''
          width={18}
          height={18}
          src={require('../assets/images/close_green.png').default}
        />
      </button>
    </div>
    <div className={styles.modal_body}>{children}</div>
  </ReactModal>
);

export default LayoffModal;
